import * as React from 'react';
import styled from 'styled-components';
import { BadgeComponent, BadgeProps } from '../Badge';
import { Badge, BadgeId } from '../../containers/Badges/Models';
import { useIntl } from 'react-intl';

interface Props {
  readonly allBadges: ReadonlyArray<Badge>;
  readonly unlockedBadgesIds: ReadonlyArray<BadgeId>;
}

const Title = styled.span`
  font-size: ${p => p.theme.font.size.XLarge};
  font-weight: ${p => p.theme.font.weight.medium};
  padding-left: 20px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 540px;
`;

const BadgesContainer = styled.div`
  padding-top: 20px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const BadgesList = (props: Props) => {
  const intl = useIntl();

  const badgesProps: ReadonlyArray<BadgeProps> = props.allBadges.map(badge => {
    return {
      isAchieved: props.unlockedBadgesIds.includes(badge.id),
      ...badge,
    };
  });

  return (
    <Container>
      <Title>
        {intl.formatMessage({
          id: 'components.Badges.MyBadges',
        })}
      </Title>
      <BadgesContainer>
        {badgesProps.map(badgeProps => {
          return <BadgeComponent key={badgeProps.id} {...badgeProps} />;
        })}
      </BadgesContainer>
    </Container>
  );
};



// WEBPACK FOOTER //
// ./src/components/BadgesList/index.tsx